/**
 * НАБОР ЭМОДЗИ
 *
 * Список свой, а не подключаемый: правило проекта — ни одного запроса
 * наружу, а готовые наборы почти всегда тянут картинки со сторонних узлов.
 * Здесь же обычные символы, которые рисует сама система, — они ничего
 * не весят и работают без сети.
 *
 * Полного набора нет и не надо: их тысячи, а в семейной переписке
 * ходят по кругу несколько сотен. Зато у каждого есть русские слова
 * для поиска — искать «торт» по английскому «cake» никто не станет.
 */

export type EmojiGroup = {
  name: string
  icon: string
  items: { char: string; words: string }[]
}

export const EMOJI: EmojiGroup[] = [
  {
    name: 'Лица',
    icon: '🙂',
    items: [
      { char: '😀', words: 'улыбка смех радость' },
      { char: '😁', words: 'улыбка зубы довольный' },
      { char: '😂', words: 'смех слёзы ржу' },
      { char: '🤣', words: 'смех катаюсь ржу' },
      { char: '🙂', words: 'улыбка спокойствие' },
      { char: '😊', words: 'улыбка смущение мило' },
      { char: '😍', words: 'влюблён сердечки любовь' },
      { char: '🥰', words: 'любовь нежность обнимашки' },
      { char: '😘', words: 'поцелуй чмок' },
      { char: '😎', words: 'очки круто' },
      { char: '🤔', words: 'думаю сомнение размышление' },
      { char: '😐', words: 'нейтрально безразлично' },
      { char: '😑', words: 'без эмоций устал' },
      { char: '🙄', words: 'закатил глаза ну конечно' },
      { char: '😅', words: 'неловко пронесло' },
      { char: '😭', words: 'плачу рыдаю' },
      { char: '😢', words: 'грусть слеза печаль' },
      { char: '😡', words: 'злость гнев бешу' },
      { char: '😴', words: 'сплю сон устал' },
      { char: '🤒', words: 'болею температура' },
      { char: '🤢', words: 'тошнит плохо' },
      { char: '🥳', words: 'праздник ура день рождения' },
      { char: '😱', words: 'ужас шок страх' },
      { char: '🤗', words: 'обнимаю обнимашки' },
      { char: '🤩', words: 'восторг вау звёзды' },
      { char: '😇', words: 'ангел невинность' },
      { char: '🥺', words: 'умоляю жалобно пожалуйста' },
      { char: '😬', words: 'неловко ой' },
      { char: '🤯', words: 'взрыв мозга офигеть' },
      { char: '🫡', words: 'есть слушаюсь честь' },
    ],
  },
  {
    name: 'Жесты',
    icon: '👍',
    items: [
      { char: '👍', words: 'класс лайк хорошо да' },
      { char: '👎', words: 'плохо не нравится нет' },
      { char: '👌', words: 'ок хорошо отлично' },
      { char: '✌️', words: 'мир виктория' },
      { char: '🤝', words: 'договорились рукопожатие' },
      { char: '🙏', words: 'спасибо пожалуйста прошу молюсь' },
      { char: '👏', words: 'аплодисменты браво молодец' },
      { char: '💪', words: 'сила молодец справимся' },
      { char: '🤞', words: 'удачи скрестил пальцы' },
      { char: '👋', words: 'привет пока машу' },
      { char: '🫶', words: 'сердце руками люблю' },
      { char: '☝️', words: 'внимание важно' },
    ],
  },
  {
    name: 'Сердца',
    icon: '❤️',
    items: [
      { char: '❤️', words: 'сердце любовь' },
      { char: '🧡', words: 'сердце оранжевое' },
      { char: '💛', words: 'сердце жёлтое' },
      { char: '💚', words: 'сердце зелёное' },
      { char: '💙', words: 'сердце синее' },
      { char: '💜', words: 'сердце фиолетовое' },
      { char: '🤍', words: 'сердце белое' },
      { char: '💔', words: 'разбитое сердце грусть' },
      { char: '💕', words: 'два сердца любовь' },
      { char: '💖', words: 'сердце блестит' },
      { char: '❤️‍🔥', words: 'сердце огонь страсть' },
    ],
  },
  {
    name: 'Люди',
    icon: '👨‍👩‍👧',
    items: [
      { char: '👨', words: 'мужчина папа' },
      { char: '👩', words: 'женщина мама' },
      { char: '👶', words: 'малыш ребёнок' },
      { char: '👦', words: 'мальчик сын' },
      { char: '👧', words: 'девочка дочь' },
      { char: '👴', words: 'дедушка' },
      { char: '👵', words: 'бабушка' },
      { char: '👨‍👩‍👧', words: 'семья' },
      { char: '👨‍👩‍👧‍👦', words: 'семья дети' },
      { char: '🧑‍⚕️', words: 'врач доктор' },
      { char: '👨‍🍳', words: 'повар готовка' },
      { char: '🐶', words: 'собака пёс' },
      { char: '🐱', words: 'кот кошка' },
    ],
  },
  {
    name: 'Еда',
    icon: '🍎',
    items: [
      { char: '🍎', words: 'яблоко фрукт' },
      { char: '🍌', words: 'банан фрукт' },
      { char: '🍓', words: 'клубника ягода' },
      { char: '🍇', words: 'виноград' },
      { char: '🥦', words: 'брокколи овощ' },
      { char: '🥕', words: 'морковь овощ' },
      { char: '🍞', words: 'хлеб батон' },
      { char: '🥛', words: 'молоко' },
      { char: '🧀', words: 'сыр' },
      { char: '🥚', words: 'яйцо' },
      { char: '🍗', words: 'курица мясо' },
      { char: '🍲', words: 'суп еда обед' },
      { char: '🍕', words: 'пицца' },
      { char: '🥗', words: 'салат' },
      { char: '🍰', words: 'торт пирожное десерт' },
      { char: '🎂', words: 'торт день рождения' },
      { char: '☕', words: 'кофе чай' },
      { char: '🍺', words: 'пиво' },
      { char: '🍷', words: 'вино' },
      { char: '🛒', words: 'покупки тележка магазин' },
    ],
  },
  {
    name: 'Дела',
    icon: '📅',
    items: [
      { char: '📅', words: 'календарь дата' },
      { char: '⏰', words: 'будильник время напоминание' },
      { char: '✅', words: 'готово сделано галочка' },
      { char: '❌', words: 'нет отмена ошибка' },
      { char: '📌', words: 'закрепить кнопка важно' },
      { char: '📝', words: 'записать заметка' },
      { char: '💊', words: 'таблетки лекарство' },
      { char: '🏥', words: 'больница врач' },
      { char: '🚗', words: 'машина авто' },
      { char: '🏠', words: 'дом' },
      { char: '🎁', words: 'подарок' },
      { char: '💰', words: 'деньги бюджет' },
      { char: '🎬', words: 'кино фильм' },
      { char: '✈️', words: 'самолёт отпуск поездка' },
      { char: '🚂', words: 'поезд билет' },
      { char: '🔥', words: 'огонь круто важно' },
      { char: '⭐', words: 'звезда важное избранное' },
      { char: '🎉', words: 'праздник ура' },
      { char: '❗', words: 'важно внимание' },
      { char: '❓', words: 'вопрос' },
    ],
  },
  {
    name: 'Погода',
    icon: '☀️',
    items: [
      { char: '☀️', words: 'солнце жара ясно' },
      { char: '⛅', words: 'облачно переменно' },
      { char: '☁️', words: 'тучи пасмурно' },
      { char: '🌧️', words: 'дождь' },
      { char: '⛈️', words: 'гроза' },
      { char: '❄️', words: 'снег мороз зима' },
      { char: '🌈', words: 'радуга' },
      { char: '🌙', words: 'ночь луна' },
      { char: '🌊', words: 'море волна' },
      { char: '🌳', words: 'дерево лес дача' },
      { char: '🌸', words: 'цветок весна' },
    ],
  },
]

/** Ищет по русским словам: «торт» находит 🍰 и 🎂. */
export function searchEmoji(query: string): string[] {
  const text = query.trim().toLowerCase()
  if (!text) return []

  const found: string[] = []
  for (const group of EMOJI) {
    for (const item of group.items) {
      if (item.words.includes(text)) found.push(item.char)
    }
  }
  return found
}

const RECENT_KEY = 'family.emoji.recent'
const RECENT_MAX = 24

export function recentEmoji(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY)
    return raw ? (JSON.parse(raw) as string[]) : []
  } catch {
    return []
  }
}

/** Только что использованные идут первыми: у каждого свой круг любимых. */
export function rememberEmoji(char: string): void {
  try {
    const current = recentEmoji().filter((c) => c !== char)
    localStorage.setItem(RECENT_KEY, JSON.stringify([char, ...current].slice(0, RECENT_MAX)))
  } catch {
    /* хранилище может быть закрыто */
  }
}
